module.exports = __webpack_public_path__ + "static/media/quitting_time_dm8t.7e682140.svg";